import { render } from "./HelpCenter.vue?vue&type=template&id=a17cddb2&scoped=true&ts=true"
import script from "./HelpCenter.vue?vue&type=script&lang=ts"
export * from "./HelpCenter.vue?vue&type=script&lang=ts"

import "./HelpCenter.vue?vue&type=style&index=0&id=a17cddb2&lang=scss&scoped=true"

import exportComponent from "/Users/zhouyuan/work/project/cargpsweb-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a17cddb2"]])

export default __exports__